import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./componentLoader.css";
const ComponentLoader = ({ color }) => {
  return (
    <div className="component_loader_container">
      <CircularProgress
        size="2rem"
        style={{ color: color ? color : "#393534" }}
      />
    </div>
  );
};

export default ComponentLoader;
